import { Image, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import { TGravity, TIconPosition } from '../../../repositories/chats/entities/action_button_v3/ActionButtonV3Schema';
import * as styles from '../styles.css';

interface IPromoProps {
  link: string;
  text: string;
  icon?: string;
  iconPosition?: TIconPosition;
  gravity?: TGravity;
  isOutcoming?: boolean;
  index?: number;
  onClick(evt: React.MouseEvent<HTMLAnchorElement>): void;
}

export function Promo({ link, text, icon, iconPosition, gravity, isOutcoming, index, onClick }: IPromoProps) {
  const textPosition = gravity && gravity === 'start' ? 'left' : 'center';

  return (
    <a
      href={link}
      target="_blank"
      onClick={onClick}
      className={styles['action_button__promo']}
      style={{
        justifyContent: textPosition,
        flexDirection: iconPosition === 'start' ? 'row' : 'row-reverse',
        marginTop: index ? '12px' : '',
      }}
      data-testid="promo"
    >
      {icon && (
        <div className={styles['promo__image']} data-name="promo_image">
          <Image src={icon} width={16} height={16} preloader={false} borderRadius="0" />
        </div>
      )}

      <UIHeading4 color={isOutcoming ? 'text-inverted-default' : 'text-main-default'}>{text}</UIHeading4>
    </a>
  );
}
